exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Sidebar-local__authors--2wu1f {\n  padding: 1rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n\n.Sidebar-local__date--2YpYi {\n  color: #6d7f92;\n  font-size: .625rem;\n  text-align: right;\n  font-weight: 400;\n  line-height: 1.2;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: end;\n      align-items: flex-end;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center; }\n", ""]);

// exports
exports.locals = {
	"authors": "Sidebar-local__authors--2wu1f",
	"date": "Sidebar-local__date--2YpYi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Reveal/Sidebar/Sidebar.local.scss
// module id = 623
// module chunks = 0